var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ECurrentLoginComponent } from "@domains/salesFeatures/Login/entities/iLogin";
import commonSalesReducer from "@redux/feature/Common/reducer/commonReducer";
import { combineReducers } from "redux";
import { CHANGE_LOGIN_COMPONENT, } from "../interface/iLoginComponent";
var initialData = {
    currentComponent: ECurrentLoginComponent.RM_PARTNER_LOGIN_TABS,
};
var changeLoginComponent = function (state, action) {
    if (state === void 0) { state = initialData; }
    switch (action.type) {
        case CHANGE_LOGIN_COMPONENT:
            return __assign(__assign({}, state), { currentComponent: action.payload.currentComponent, extraConfig: action.payload.extraConfig });
        default:
            return __assign({}, state);
    }
};
export default combineReducers({
    reducersData: changeLoginComponent,
    commonData: commonSalesReducer,
});
